import React, { useEffect } from 'react';
import { useLoaderData } from '@tanstack/react-router';

import { APIregisterTimelineView } from '../api/Timeline';
import { getHeaderCrop, getHeaderImageStyle } from '../helpers/header-image';

import TimelineHeader from '../components/Timeline/Header';
import TimelineMemoryCard from '../components/Timeline/MemoryCard';
import TimelineButtons from '../components/Timeline/Buttons';
import TimelineStats from '../components/Timeline/Stats';
import MemoryTimeline from '../components/Memory/Timeline';
import TimelineReactions from '../components/Timeline/Reactions';
import TimelineContributors from '../components/Timeline/Contributors';
import TimelineContributorInvite from '../components/Timeline/ContributorInvite';
import TimelineContributorNotice from '../components/Timeline/ContributorNotice';
import Notices from '../components/Notices';

import type { Memory } from '../types/memory';

const TimelineView: React.FC = () => {
  const {
    timeline,
    mode,
  } = useLoaderData({ strict: false });

  useEffect(() => {
    if (mode === 'public') {
      APIregisterTimelineView(timeline.id);
    }
  }, [timeline.id, mode]);

  return (
    <div className="container timeline-view-container">
      <div
        className={`timeline-header wa-stack wa-gap-0 inner${timeline.header_image ? ' has-header-image' : ''}`}
      >
        {timeline.header_image && (
          <div className="timeline-header-background">
            <img
              src={timeline.header_image.path}
              alt=""
              style={getHeaderImageStyle(getHeaderCrop(timeline.header_image.metadata))}
            />
          </div>
        )}
        <Notices />
        <TimelineHeader
          timeline={timeline}
          mode={mode}
        />
      </div>
      <div className="wa-flank wa-flank:end wa-gap-0 wa-align-items-start" style={{ '--flank-size': '400px' } as React.CSSProperties}>
        <div className={`timeline-view wa-stack${timeline.contributor ? ' timeline-view-contributor' : ''}`}>
          {timeline.contributor && (
            <>
              {timeline.contributor.accepted_at ? (
                <TimelineContributorNotice />
              ) : (
                <TimelineContributorInvite timeline={timeline} />
              )}
            </>
          )}
          <div className="timeline-view-line" />
          <div className="timeline-view-inner wa-stack inner">
            {timeline.memories.map((memory: Memory) => (
              <TimelineMemoryCard
                key={memory.id}
                memory={memory}
                timeline={timeline}
                mode={mode}
              />
            ))}
          </div>
        </div>
        <div className="timeline-view-sidebar inner">
          {mode === 'private' ? (
            <>
              <TimelineButtons timeline={timeline} page="view" />
              <TimelineStats timeline={timeline} />
              <TimelineContributors timeline={timeline} />
            </>
          ) : (
            <>
              <TimelineButtons timeline={timeline} page="public" />
              <MemoryTimeline timeline={timeline} />
              {timeline.allow_reactions && (
                <TimelineReactions timeline={timeline} />
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default TimelineView;
